import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import { analyticsPageView } from 'global/helpers/analytics'
import { memo, type ReactElement, type SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CarrierProfileBanner from 'screens/CarrierProfile/CarrierProfileBanner'
import { CarrierProfileTab } from './CarrierProfile.types'
import CompanyTab from './CompanyTab'
import ContactsTab from './ContactsTab'
import EquipmentTab from './EquipmentTab'
import LanesAndRegionsTab from './LanesAndRegionsTab'

const CarrierProfile = (): ReactElement => {
  const { t } = useTranslation()
  const [topbarView, setTopbarView] = useState<CarrierProfileTab>(CarrierProfileTab.LANES_REGIONS)

  const handleTopbarViewOnChange = useCallback((_event: SyntheticEvent, value: CarrierProfileTab) => {
    setTopbarView(value)
  }, [])

  useEffect(() => {
    analyticsPageView('polestar/carrier-profile')
  }, [])

  return (
    <Container
      data-test="carrier-profile-container"
      maxWidth="xxl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <CarrierProfileBanner />
      <Paper sx={{ padding: 2 }}>
        <Tabs
          variant="fullWidth"
          value={topbarView}
          onChange={handleTopbarViewOnChange}
          sx={{ margin: '-1rem -1rem 1rem' }}
        >
          <Tab
            value={CarrierProfileTab.LANES_REGIONS}
            label={t('screens.cs.carrier_profile.topbar.lanes-regions')}
          />
          <Tab
            value={CarrierProfileTab.COMPANY}
            label={t('screens.cs.carrier_profile.topbar.company')}
          />
          <Tab
            value={CarrierProfileTab.CONTACTS}
            label={t('screens.cs.carrier_profile.topbar.contacts')}
          />
          <Tab
            value={CarrierProfileTab.EQUIPMENT}
            label={t('screens.cs.carrier_profile.topbar.equipment')}
          />
        </Tabs>

        {topbarView === CarrierProfileTab.LANES_REGIONS && <LanesAndRegionsTab />}
        {topbarView === CarrierProfileTab.COMPANY && <CompanyTab />}
        {topbarView === CarrierProfileTab.CONTACTS && <ContactsTab />}
        {topbarView === CarrierProfileTab.EQUIPMENT && <EquipmentTab />}
      </Paper>
    </Container>
  )
}

export default memo(CarrierProfile)
